import classNames from 'classnames';
import { useState } from 'react';

interface ISquareRadio {
  id: string;
  value: string;
  name: string;
  handleChange: (optionGroup: string, option: string) => void;
  valueSelected: string[];
  optionGroupKey: string
}

const SquareRadio = ({
  id,
  value,
  name,
  handleChange,
  valueSelected,
  optionGroupKey
}: ISquareRadio) => {
  const handleChangeCheckbox = () =>
    //event: Omit<React.ChangeEvent<HTMLInputElement>, 'dangerouslySetInnerHTML'>,
    {
      handleChange(optionGroupKey, id);
    };

  const checked = valueSelected.includes(id);
  
  return (
    <div className="mb-2">
      {/* onChange={handleChangeCheckbox} */}
      <button
        className={classNames(
          'block cursor-pointer select-none text-base px-5 py-[1px] border-solid rounded-[20px] border-[2px] border-secondary text-center mr-5 ',
          {
            'bg-secondary font-bold text-white': checked,
          },
        )}
        id={`${id}${name}`}
        onClick={handleChangeCheckbox}>
        {value}
      </button>
    </div>
  );
};
export default SquareRadio;
